module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_6005.86bdf53b.png";